/* Longevity Theme — Scroll animations & sticky ATC */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Intersection Observer for .animate-on-scroll elements
     ---------------------------------------------------------- */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -36px 0px' }
  );

  function initScrollAnimations() {
    /* Observe explicitly marked elements in Liquid */
    document.querySelectorAll('.animate-on-scroll').forEach(function (el) {
      observer.observe(el);
    });

    /* Auto-add animate-on-scroll to section headers & safe targets
       (elements NOT inside reveal-items, which has its own animation) */
    var autoSelectors = [
      '.shopify-section--logo-list .section-header',
      '.shopify-section--featured-collection .section-header',
      '.shopify-section--impact-text .section-header',
      '.shopify-section--image-link-blocks .section-header',
      '.fc-benefits',
      '.shopify-section--text-with-icons .text-with-icons__item',
      '.shopify-section--press .press__controls',
    ];

    document.querySelectorAll(autoSelectors.join(', ')).forEach(function (el, i) {
      if (!el.classList.contains('animate-on-scroll')) {
        el.classList.add('animate-on-scroll');
        el.style.transitionDelay = Math.min(i * 0.06, 0.3) + 's';
        observer.observe(el);
      }
    });

    /* Stagger trust-bar items */
    document.querySelectorAll('.shopify-section--text-with-icons .text-with-icons__item').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.12) + 's';
    });
  }

  /* ----------------------------------------------------------
     Sticky Add-to-Cart bar — mobile homepage only
     ---------------------------------------------------------- */
  function initStickyATC() {
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;
    var hero = document.querySelector('.shopify-section--slideshow');
    if (!hero) return;

    var heroObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    heroObserver.observe(hero);
  }

  /* ----------------------------------------------------------
     Boot
     ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollAnimations();
      initStickyATC();
    });
  } else {
    initScrollAnimations();
    initStickyATC();
  }
})();
